// extracted by mini-css-extract-plugin
export default {"mainClass":"subscription_mainClass__1YIFP","h1":"subscription_h1__tyMga","tabClass":"subscription_tabClass__P8PF-"};